import { ReactNode } from "react";
import { makeStyles, mergeClasses } from "@fluentui/react-components";
import { useCommonStyles } from "./Styles/commonStyles";
import { Column, ColumnProps } from "./Column";

const useStyles = makeStyles({
    flush: {
        width: 'fit-content',
    }
});
export type ContainerProps = ColumnProps & {
    children: ReactNode;
    className?: string;
    flush?: boolean;
};
export const Container = (props: ContainerProps) => {

    const { children, className, flush=false, ...otherProps } = props;

    //Styles
    const commonStyles = useCommonStyles();
    const styles = useStyles();
    const containerClasses = mergeClasses(
        commonStyles.container.root,
        !!flush && styles.flush,
        className,
    );

    return (
        <Column className={containerClasses} {...otherProps}>
            {children}
        </Column>
    );
};